import React from 'react';
import EyeIcon from 'src/common/utils/TableColumnIcons/EyeIcon';

export const ActionColumnDetail = (value, row, rowIndex, { onEye }) => {
	return (
		<>
			<EyeIcon onClick={() => onEye(row)} color="primary" />
		</>
	);
};
